import { getBaseBreadcrumb, getHomeBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';

export const GLOSSARY_CONTENT_PATH = '/glossary/index';
export const GLOSSARY_BREADCRUMBS = [getHomeBreadcrumb(), getBaseBreadcrumb('Automotive Glossary', '/glossary/')];

export const GLOSSARY_CATEGORIZED_CONTENT_PATH = '/glossary/glossary-categorized';
export const GLOSSARY_CATEGORIZED_BREADCRUMBS = [
  ...GLOSSARY_BREADCRUMBS,
  getBaseBreadcrumb('Categorized Glossary', '/glossary/glossary-categorized.html'),
];
